export default __webpack_public_path__ + "static/dobychin-9d65c4cce7a49018f71a41a3bff7ef60.png";